import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sales-report-type',{model:{value:(_vm.params),callback:function ($$v) {_vm.params=$$v},expression:"params"}}),_c(VDivider,{attrs:{"vertical":""}}),_c('sales-report-view-type',{model:{value:(_vm.params),callback:function ($$v) {_vm.params=$$v},expression:"params"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }